module.exports = __webpack_public_path__ + "img/logo-ifth.52904ac5.png";